import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Button from "@material-ui/core/Button";
import avatar from "../../images/png/avatar.png";
import ArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const styles = theme => ({
  hero: {
    alignItems: "center",
    background: theme.hero.background,
    backgroundImage: props => `url(${props.backgrounds.mobile})`,
    backgroundSize: "cover",
    color: theme.palette.primary.main,
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "space-between",
    minHeight: "100vh",
    height: 100,
    padding: theme.spacing.unit,
    paddingTop: theme.header.height.homepage + 120,
    paddingBottom: 50,
    [`@media (max-width: ${theme.mediaQueryTresholds.M - 1}px)`]: {
      paddingTop: theme.header.height.homepage + 10
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {
      backgroundImage: props => `url(${props.backgrounds.tablet})`
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      backgroundImage: props => `url(${props.backgrounds.desktop})`
    }
  },
  content: {
    textAlign: "center",
    color: theme.palette.primary.main,
    textRemoveGap: "both 0 'Open Sans'",
    fontSize: "1.3em",
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {
      fontSize: "1.5em"
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      fontSize: "1.8em"
    },
    "& h1": {
      fontWeight: 400,
      margin: 0,
      textShadow: "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
      color: theme.palette.secondary.main
    },
    "& h2": {
      fontWeight: 400,
      margin: 0,
      textShadow: "-1px -1px 0 rgba(255,255,255,.8), 1px -1px 0 rgba(255,255,255,.8), -1px 1px 0 rgba(255,255,255,.8), 1px 1px 0 rgba(255,255,255,.8)",
      color: theme.palette.primary.contrastText
    }
  },
  arrowDown: {},
  invisible: {
    position: "absolute",
    top: 0,
    margin: 0,
    border: 0
  }
});

/*{ --- STYLES ---
      <style jsx>{`

        @from-width tablet {
          .hero {
            background-image: url(${backgrounds.tablet}),
          }

          h1 {
            max-width: 90%,
            font-size: ${`calc(${theme.hero.h1.size} * 1.3)`},
          }

          button {
            font-size: ${theme.font.size.l},
          }
        }

        @from-width desktop {
          .hero {
            background-image: url(${backgrounds.desktop}),
          }

          h1 {
            max-width: 80%,
            font-size: ${`calc(${theme.hero.h1.size} * 1.5)`},
          }

          button {
            font-size: ${theme.font.size.xl},
          }
        }
      `}</style>*/

const Hero = props => {
  const { separators, classes } = props;
  return (
    <React.Fragment>
      <hr ref={separators[0]} className={classes.invisible} />
      <section className={classes.hero}>
        <div className={classes.content}>
          <div className={classes.avatar}>
            <img src={avatar} />
          </div>
          <h1>Monika Bandelewska</h1>
          <h2>Kancelaria Radcy Prawnego</h2>
        </div>
        <Button color="secondary" variant="fab" onClick={() => props.scrollToContent(1)}>
          <ArrowDownIcon />
        </Button>
      </section>
    </React.Fragment>
  );
};

Hero.propTypes = {
  backgrounds: PropTypes.object.isRequired,
  separators: PropTypes.array.isRequired,
  scrollToContent: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(Hero);



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js